function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.closeButton = this.querySelector('.menu-drawer__close');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.closeButton?.addEventListener('click', this.closeMenuDrawerOnClick.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__close)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    // this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
    //   details.removeAttribute('open');
    //   details.classList.remove('menu-opening');
    // });
    // this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
    //   submenu.classList.remove('submenu-open');
    // });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  closeMenuDrawerOnClick() {
    this.mainDetailsToggle.querySelector('summary')?.click();
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

  }

  connectedCallback() {
    const mainSummaryElements = this.querySelectorAll('.menu-drawer__menu-item');
    mainSummaryElements.forEach((summary) => {
      summary.addEventListener('click', () => {
        mainSummaryElements.forEach((otherSummary) => {
          if (otherSummary !== summary)
            otherSummary.parentElement.removeAttribute('open');
        });
      });
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      console.log('modal', modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    const slider = this.slider;
    const start = slider.scrollLeft;
    const distance = position - start;
    const duration = 500; // Animation duration in milliseconds
    let startTime = null;

    const animateScroll = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1); // Ensure it doesn't exceed 1

      // Ease-in-out function for smooth animation
      const easeInOut = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

      // Update scrollLeft based on the animation progress
      slider.scrollLeft = start + distance * easeInOut(percentage);

      // Continue the animation until the duration is complete
      if (progress < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    // Start the animation
    requestAnimationFrame(animateScroll);
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    // if (isFirstSlide && event.currentTarget.name === 'previous') {
    //   this.slideScrollPosition =
    //     this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    // } else if (isLastSlide && event.currentTarget.name === 'next') {
    //   this.slideScrollPosition = 0;
    // }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Initialize installment amount on page load
    this.updateInstallmentAmount();
    
    this.addEventListener('change', (event) => {
      // const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      // publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      //   data: {
      //     event,
      //     target,
      //     selectedOptionValues: this.selectedOptionValues,
      //   },
      // });

      // // Synchronize state between select and input elements
      // this.synchronizeState(event.target);

      try {
        this.onVariantChange(event);
      } catch (error) {
        console.error(error);
      }
    });

    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', this.handleInputChange.bind(this));
    });

    this.querySelectorAll('.product-form__input-select').forEach((select) => {
      const selectLabel = select.querySelector('.product-form__input-select-label');
      selectLabel?.addEventListener('click', () => {
        select.classList.toggle('open');
      });

      const inputs = select.querySelectorAll('input[type="radio"]');
      inputs.forEach((input) => {
        input.addEventListener('click', () => {
          select.classList.remove('open');
          select.querySelector('[data-input-select-value]').textContent = `: ${input.value}`;
        });
      });
    });

    this.attentiveHandler();
  }

  handleInputChange(event) {
    const selectedInput = event.target;
    this.updateCheckedClass(selectedInput);
  }

  updateCheckedClass(selectedInput) {
    // Remove checked class from all labels
    this.querySelectorAll('label.checked').forEach((label) => {
      label.classList.remove('checked');
    });

    // Add checked class to the selected label
    const selectedLabel = this.querySelector(`label[for="${selectedInput.id}"]`);
    if (selectedLabel) {
      selectedLabel.classList.add('checked');
    }
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target.closest('.product-form__input').querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset',
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(({ dataset }) => dataset.optionValueId);
  }

  synchronizeState(changedElement) {
    const { tagName, value } = changedElement;

    if (tagName === 'SELECT') {
      const correspondingInput = this.querySelector(`input[type="radio"][value="${value}"]`);
      if (correspondingInput) {
        correspondingInput.checked = true;
      }
    } else if (tagName === 'INPUT' && changedElement.type === 'radio') {
      const correspondingSelect = this.querySelector(`select option[value="${value}"]`);
      if (correspondingSelect) {
        correspondingSelect.selected = true;
        correspondingSelect.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateInventoryStatus();
    this.updateShippingInformation();
    this.updateButton();

    if (this.currentVariant) {
      this.updateVariantInput();
      this.updateURL();
      this.updatePrice();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updatePrice() {
    const priceWrappers = document.querySelectorAll(`
      #price-${this.dataset.section}, #price-title-${this.dataset.section}`);
    priceWrappers.forEach((priceWrapper) => {
      const price = priceWrapper.querySelector('.price');
      price.classList.toggle('price--on-sale', this.currentVariant.compare_at_price > this.currentVariant.price);

      price.innerHTML = `<div class="price__container">
                          <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                              <span class="price-item price-item--regular">
                                ${formatMoney(this.currentVariant.price, window.moneyFormat).replace(/\.00$/, '')}
                              </span>
                            </div>
                          <div class="price__sale">
                              <span class="visually-hidden visually-hidden--inline">Regular price</span>
                              <span>
                                <s class="price-item price-item--regular">
                                  ${formatMoney(this.currentVariant.compare_at_price, window.moneyFormat).replace(/\.00$/, '')}
                                </s>
                              </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
                            <span class="price-item price-item--sale price-item--last">
                              ${formatMoney(this.currentVariant.price, window.moneyFormat).replace(/\.00$/, '')}
                            </span>
                          </div>
                        </div>`;
    });

    // Update installment amount
    this.updateInstallmentAmount();
  }

  updateInstallmentAmount() {
    const installmentElement = document.querySelector('.installment-amount');
    const variant = this.getCurrentVariant();
    if (installmentElement && variant) {
      const installmentAmount = (variant.price / 400).toFixed(2);
      installmentElement.textContent = `$${installmentAmount}`;
    }
  }

  updateInventoryStatus() {
    const inventoryStatusEls = this.closest('product-info').querySelectorAll('.variant-inventory__message');
    const { available, inventory_quantity } = this.currentVariant;

    inventoryStatusEls.forEach((inventoryStatus) => {
      if (!this.currentVariant) {
        inventoryStatus.classList.add('hidden');
      } else {
        inventoryStatus.classList.remove('success', 'warning', 'hidden');
        inventoryStatus.textContent = '';

        if (available && inventory_quantity > 0) {
          if (inventory_quantity > 10) {
            inventoryStatus.classList.add('success');
            inventoryStatus.textContent = 'In Stock, Ready To Ship!';
          } else {
            inventoryStatus.classList.add('warning');
            inventoryStatus.textContent = `Only ${inventory_quantity} left in stock!`;
          }
        } else {
          inventoryStatus.classList.add('warning');
          inventoryStatus.textContent = 'Out of Stock';
        }
      }
    });
  }

  updateShippingInformation() {
    const shippingInfoData = JSON.parse(this.querySelector('[data-shipping-information]')?.textContent || '[]');
    const shippingInfo =
      shippingInfoData.variants.find((variant) => variant.id === this.currentVariant.id && variant.text !== '') || shippingInfoData;

    const shippingInfoInput = this.closest('product-info').querySelector('[name="properties[Shipping Info]"]');
    if (shippingInfoInput) shippingInfoInput.value = shippingInfo?.text;

    const shippingInfoEls = this.closest('product-info').querySelectorAll('.product-shipping-message');
    shippingInfoEls.forEach((ShippingInfo) => {
      if (!this.currentVariant) {
        ShippingInfo.classList.add('hidden');
        ShippingInfo.textContent = '';
      } else {
        ShippingInfo.classList.toggle('hidden', shippingInfo?.text == '');
        ShippingInfo.textContent = shippingInfo?.text;
      }
    });
  }

  updateButton() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const template = this.dataset.template;
    console.log('template', template);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const attnBtnTrigger = document.getElementById('attn-waitlist-trigger');

    addButton.classList.remove('hidden');

    if (!this.currentVariant) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = window.variantStrings.unavailable;
    } else if (this.currentVariant.available) {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = template === 'giftcard' ? window.variantStrings.send_to_me : window.variantStrings.addToCart;
      attnBtnTrigger?.classList.add('attn-hidden');
      addButton.classList.remove('hidden');
    } else {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = window.variantStrings.soldOut;
      attnBtnTrigger?.classList.remove('attn-hidden');
      addButton.classList.add('hidden');
      this.attentiveHandler();
    }
  }

  attentiveHandler() {

    const bellIconSvg = `<svg width="26" height="26" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.75038 3.4287C8.77551 3.47719 8.79083 3.53015 8.79549 3.58457C8.80014 3.63899 8.79403 3.69378 8.7775 3.74584C8.76097 3.79789 8.73435 3.84618 8.69916 3.88794C8.66397 3.92971 8.6209 3.96413 8.5724 3.98925C7.36645 4.61389 6.32375 5.5126 5.52805 6.61322C4.73234 7.71384 4.20578 8.9857 3.99066 10.3267C3.98251 10.381 3.96366 10.4332 3.93521 10.4803C3.90676 10.5273 3.86927 10.5682 3.8249 10.6007C3.78054 10.6331 3.73018 10.6564 3.67674 10.6693C3.6233 10.6822 3.56784 10.6843 3.51357 10.6756C3.4593 10.6669 3.40729 10.6475 3.36056 10.6186C3.31382 10.5897 3.27328 10.5518 3.24129 10.5071C3.20929 10.4624 3.18647 10.4118 3.17415 10.3582C3.16183 10.3047 3.16026 10.2492 3.16951 10.195C3.40519 8.72561 3.98213 7.33196 4.854 6.12595C5.72588 4.91993 6.8684 3.93517 8.18983 3.25072C8.23832 3.22559 8.29129 3.21027 8.3457 3.20561C8.40012 3.20096 8.45492 3.20707 8.50697 3.2236C8.55902 3.24013 8.60731 3.26675 8.64908 3.30194C8.69084 3.33713 8.72527 3.3802 8.75038 3.4287Z" fill="white"/>
    <path d="M9.5364 4.94713C9.58705 5.04503 9.59676 5.15905 9.56338 5.26411C9.53001 5.36917 9.45628 5.45668 9.35842 5.5074C8.38982 6.00906 7.55236 6.73085 6.91326 7.61481C6.27417 8.49877 5.85126 9.52028 5.6785 10.5973C5.65968 10.7049 5.59926 10.8008 5.51032 10.8642C5.42137 10.9277 5.31104 10.9535 5.20316 10.9363C5.09529 10.919 4.99854 10.86 4.93383 10.772C4.86912 10.684 4.84164 10.574 4.85735 10.4659C5.05065 9.26043 5.52393 8.11708 6.23919 7.12768C6.95445 6.13827 7.89176 5.33037 8.97584 4.76887C9.02435 4.74375 9.07733 4.72844 9.13176 4.72381C9.18619 4.71918 9.24099 4.72531 9.29305 4.74187C9.3451 4.75842 9.39339 4.78507 9.43514 4.82029C9.4769 4.85551 9.5113 4.89861 9.5364 4.94713ZM18.6411 5.5074C18.5914 5.48298 18.5471 5.44889 18.5108 5.40713C18.4745 5.36537 18.4469 5.31677 18.4296 5.26419C18.4123 5.21162 18.4056 5.15612 18.4101 5.10094C18.4145 5.04577 18.4299 4.99204 18.4554 4.9429C18.4808 4.89375 18.5159 4.85019 18.5584 4.81476C18.6009 4.77932 18.6501 4.75274 18.703 4.73655C18.7559 4.72037 18.8116 4.71492 18.8666 4.72052C18.9217 4.72611 18.9751 4.74264 19.0237 4.76915C20.1077 5.33068 21.0449 6.13854 21.7602 7.12789C22.4754 8.11724 22.9488 9.2605 23.1422 10.4659C23.1514 10.5201 23.1499 10.5756 23.1375 10.6291C23.1252 10.6827 23.1024 10.7333 23.0704 10.778C23.0384 10.8227 22.9979 10.8606 22.9511 10.8895C22.9044 10.9184 22.8524 10.9378 22.7981 10.9465C22.7439 10.9552 22.6884 10.9531 22.635 10.9402C22.5815 10.9273 22.5312 10.904 22.4868 10.8716C22.4424 10.8391 22.4049 10.7982 22.3765 10.7512C22.348 10.7041 22.3292 10.6519 22.321 10.5976C22.1482 9.52057 21.7253 8.49908 21.0862 7.61513C20.4471 6.73117 19.6097 6.00937 18.6411 5.50768V5.5074Z" fill="white"/>
    <path d="M19.2497 3.42871C19.2246 3.47721 19.2093 3.53017 19.2046 3.58459C19.2 3.639 19.2061 3.6938 19.2226 3.74586C19.2392 3.79791 19.2658 3.8462 19.301 3.88796C19.3362 3.92973 19.3792 3.96415 19.4277 3.98927C20.6337 4.61393 21.6763 5.51264 22.4721 6.61326C23.2678 7.71387 23.7943 8.98572 24.0095 10.3267C24.0176 10.3811 24.0365 10.4333 24.0649 10.4803C24.0934 10.5273 24.1309 10.5682 24.1752 10.6007C24.2196 10.6331 24.2699 10.6565 24.3234 10.6693C24.3768 10.6822 24.4323 10.6843 24.4866 10.6756C24.5408 10.6669 24.5928 10.6475 24.6396 10.6186C24.6863 10.5897 24.7268 10.5518 24.7588 10.5071C24.7908 10.4624 24.8136 10.4118 24.826 10.3582C24.8383 10.3047 24.8399 10.2492 24.8306 10.195C24.5949 8.7256 24.0179 7.33193 23.146 6.12592C22.2741 4.9199 21.1315 3.93515 19.81 3.25073C19.7121 3.20017 19.5982 3.19051 19.4932 3.22388C19.3882 3.25725 19.3007 3.33092 19.25 3.42871H19.2497Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50587 12.8181V16.8869H7.43878C7.06828 16.8943 6.71544 17.0466 6.45601 17.3112C6.19659 17.5758 6.05127 17.9316 6.05127 18.3022C6.05127 18.6728 6.19659 19.0285 6.45601 19.2932C6.71544 19.5578 7.06828 19.7101 7.43878 19.7174H20.5616C20.7498 19.7212 20.9369 19.6873 21.1119 19.6179C21.2868 19.5484 21.4462 19.4448 21.5806 19.313C21.715 19.1812 21.8218 19.0239 21.8947 18.8503C21.9676 18.6768 22.0052 18.4904 22.0052 18.3022C22.0052 18.1139 21.9676 17.9276 21.8947 17.754C21.8218 17.5805 21.715 17.4232 21.5806 17.2914C21.4462 17.1596 21.2868 17.056 21.1119 16.9865C20.9369 16.9171 20.7498 16.8832 20.5616 16.8869H20.4948V12.8181C20.4948 9.23157 17.587 6.32373 14.0002 6.32373C10.4134 6.32373 7.50587 9.23129 7.50587 12.8181ZM8.33755 17.7186V12.8181C8.33755 9.69066 10.8728 7.15541 14.0002 7.15541C17.1276 7.15541 19.6631 9.69066 19.6631 12.8181V17.7186H20.5616C20.6398 17.7162 20.7176 17.7295 20.7905 17.7578C20.8634 17.786 20.9299 17.8286 20.9861 17.883C21.0422 17.9375 21.0868 18.0026 21.1173 18.0746C21.1478 18.1466 21.1635 18.224 21.1635 18.3022C21.1635 18.3804 21.1478 18.4578 21.1173 18.5298C21.0868 18.6018 21.0422 18.6669 20.9861 18.7213C20.9299 18.7758 20.8634 18.8184 20.7905 18.8466C20.7176 18.8748 20.6398 18.8882 20.5616 18.8857H7.43878C7.36063 18.8882 7.2828 18.8748 7.20989 18.8466C7.13698 18.8184 7.07049 18.7758 7.01436 18.7213C6.95823 18.6669 6.9136 18.6018 6.88313 18.5298C6.85265 18.4578 6.83695 18.3804 6.83695 18.3022C6.83695 18.224 6.85265 18.1466 6.88313 18.0746C6.9136 18.0026 6.95823 17.9375 7.01436 17.883C7.07049 17.8286 7.13698 17.786 7.20989 17.7578C7.2828 17.7295 7.36063 17.7162 7.43878 17.7186H8.33755ZM11.1267 21.2195C11.0486 20.9491 11.0089 20.6692 11.0089 20.3878H16.9915C16.9917 20.9795 16.8163 21.5579 16.4877 22.05C16.159 22.542 15.6918 22.9255 15.1451 23.1519C14.5985 23.3784 13.9969 23.4376 13.4166 23.3221C12.8363 23.2066 12.3032 22.9215 11.885 22.503C11.5279 22.146 11.2671 21.7045 11.1267 21.2195ZM15.5277 21.9147C15.7268 21.7156 15.885 21.4794 15.9935 21.2195H12.0075C12.1441 21.5468 12.3592 21.8354 12.6338 22.0599C12.9084 22.2844 13.2341 22.4377 13.5821 22.5065C13.93 22.5752 14.2896 22.5572 14.6289 22.454C14.9683 22.3508 15.2769 22.1656 15.5277 21.9147Z" fill="white"/>
    <path d="M13.348 4.7627C13.2377 4.7627 13.1319 4.80651 13.0539 4.88449C12.9759 4.96248 12.9321 5.06825 12.9321 5.17854C12.9321 5.28882 12.9759 5.3946 13.0539 5.47258C13.1319 5.55057 13.2377 5.59438 13.348 5.59438H14.6523C14.7626 5.59438 14.8684 5.55057 14.9464 5.47258C15.0244 5.3946 15.0682 5.28882 15.0682 5.17854C15.0682 5.06825 15.0244 4.96248 14.9464 4.88449C14.8684 4.80651 14.7626 4.7627 14.6523 4.7627H13.348Z" fill="white"/>
    </svg>
    `;
    // Function to update the button content
    const updateAttnButton = () => {
      const button = document.getElementById('attn-waitlist-trigger-btn');
      if (button) {
        if (button.innerText.trim() === 'Notify me when this is back in stock') {
          button.innerHTML = `${bellIconSvg} Sold out, notify me`;
        }
        window.__attentive.trigger();

        return true; // Return true if the button is found and updated
      }
      return false; // Return false if the button is not found
    };

    // Function to periodically check for the button
    const checkForButton = () => {
      const buttonFound = updateAttnButton();
      if (!buttonFound) {
        setTimeout(checkForButton, 500); // Check again after 500 milliseconds
      }
    };

    // Initial call to start checking for the button
    checkForButton();
  }

  getVariantData() {
    this.variantData = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
    return this.variantData;
  }

  getCurrentVariant() {
    this.updateOptions();

    return this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class ProductsTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.products-tabs__tab');
    this.tabsContent = this.querySelectorAll('.products-tabs__products');
    this.tabsShopLinks = this.querySelectorAll('.products-tabs__shop-link a');

    this.tabs.forEach((tab) =>
      tab.addEventListener('click', this.onTabClick.bind(this, tab)
      ));
  }

  onTabClick(currentTab) {
    this.tabs.forEach((tab) => tab.classList.remove('active'));
    currentTab.classList.add('active');

    this.tabsContent.forEach((content) => content.classList.remove('active'));
    this.querySelector(`#ProductTabs-${currentTab.dataset.id}`).classList.add('active');

    this.tabsShopLinks.forEach((link) => {
      link.parentElement.classList.toggle('hidden', currentTab.dataset.shopLink == '');
      link.href = currentTab.dataset.shopLink;
    });
  }
}

if (!customElements.get('products-tabs')) {
  customElements.define('products-tabs', ProductsTabs);
}

// Function to handle scroll event
function handleScroll() {
  if (window.scrollY > 50) {
    document.body.classList.add('search-scroll-fixed');
  } else {
    document.body.classList.remove('search-scroll-fixed');
  }
}
window.addEventListener('scroll', handleScroll);

// Adding class to body before page load to prevent layout shifts
window.addEventListener("load", function () {
  document.body.classList.remove("before-load");
});

function initProductImageSlider() {
  const slider = new Swiper('.product-card__media-slider', {
    slidesPerView: 1,
    slidesToScroll: 1,
    loop: true,
    speed: 900,
    easing: 'linear',
    pagination: {      
      el: '.swiper-pagination',
      clickable: true
    },    
    navigation: {
      nextEl: null,
      prevEl: null,
    },
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initProductImageSlider();
});

// function to initialize the product card back and forth slider
function initProductCardSlider() {
  const firstSlider = document.querySelector('.plp-single-product-image-slider');
  if (!firstSlider) return;

  if (firstSlider.swiper && typeof firstSlider.swiper.destroy === 'function') {
    firstSlider.swiper.destroy(true, true);
  }

  let animationStarted = false;

  const swiper = new Swiper(firstSlider, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 900,
    effect: 'slide',
    cssEase: 'ease',
    easing: 'linear',
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    on: {
      init: function() {
        setTimeout(() => {
          if (animationStarted) return;
          animationStarted = true;
          this.slideToLoop(0, 0, false);
          setTimeout(() => {
            // Calculate 70% of the slide width
            const slide = this.slides[0];
            const slideWidth = slide ? slide.offsetWidth : 0;
            const seventyPercent = slideWidth * 0.7;
            // Move forward by 70%
            this.translateTo(-seventyPercent, 900);
            setTimeout(() => {
              // Move back to start
              this.translateTo(0, 900);
            }, 900);
          }, 100);
        }, 1100);
      }
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.startsWith('/collections')) {
    initProductCardSlider();

    document.querySelectorAll('.products-view-trigger-wrapper').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        initProductCardSlider();
      });
    });
  }
});